export default __webpack_public_path__ + "static/media/abhi.0242ba57.jpg";